<template>
    <div class="relative teaser" v-if="news.title">
        <router-link v-bind:to="news.router">
            <div class="borderElement">
                <picture>
                    <img v-bind:src="news.image" class="newsimg">
                </picture>
            </div>
            <h2 class="bg-white px-4 py-5">
                <span class="gradientText lg:text-4xl md:leading-relaxed title block">
                    <the-language :de="news.title" :en="news.title_en" />
                </span>
                <div class="text-primary-red more">
                    <span class="lang-de">mehr...</span>
                    <span class="lang-en">more...</span>
                </div>
            </h2>
        </router-link>
    </div>
</template>

<script>

    import TheLanguage from "../TheLanguage";

    export default {
        name: 'teaserView',
        components: {
            TheLanguage
        },
        data() {
            return {

            }
        },
        props: {
            news: {
                type: Object,
                default: () => {}
            }
        }
    }
</script>

<style lang="scss" scoped>
    .newsimg{
        max-width: 80%;
    }
    h2{
        position: absolute;
        bottom: -20px;
        right: 10px;
        width: 80%;
        line-height: 1.7rem;
        font-weight: bold;
        transition: all ease-in .4s;
        box-shadow: 0px -1px 21px -5px rgba(0,0,0,0.6);
        word-break: break-word;
        .more{
            font-weight: lighter;
            font-size: 0.8rem;
        }
        &:before,
        &:after{
            content: '';
            width: 8px;
            height: 40px;
            position: absolute;
        }
        &:before{
           @apply bg-primary-red;
            left: 0;
            top: 0;
        }
        &:after{
            @apply bg-primary-green;
            right: 0px;
            bottom: 0;
        }
        .more{
            position: absolute;
            bottom: 0px;
            right: 15px;
        }
    }
    .teaser{
        img{
            transition: transform 6s cubic-bezier(.19,1,.22,1);
        }
        &:hover{
            img{
                transform: scale(1.1);
            }
        }
    }
</style>